module.exports = __webpack_public_path__ + "static/media/ic_bag.00b0d4d5.svg";